<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(register)">
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <h4>{{ $t('app.modules.register.title') }}</h4>

            <div class="row">
              <div class="col-1"></div>
              <div class="col-10">
                <card card-body-classes="table-full-width" no-footer-line>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-6">
                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.business_name')"
                          :placeholder="$t('app.modules.register.headers.business_name')"
                          v-model="item.business_name"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.rfc')"
                          :placeholder="$t('app.modules.register.headers.rfc')"
                          v-model="item.rfc"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.fullname')"
                          :placeholder="$t('app.modules.register.headers.fullname')"
                          v-model="item.fullname"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.country')"
                          :placeholder="$t('app.modules.register.headers.country')"
                          v-model="item.country"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.comment')"
                          :placeholder="$t('app.modules.register.headers.comment')"
                          v-model="item.comment"
                        >
                        </fg-input>
                      </div>
                      <div class="col-6">
                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.tel')"
                          :placeholder="$t('app.modules.register.headers.tel')"
                          v-model="item.tel"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.email')"
                          :placeholder="$t('app.modules.register.headers.email')"
                          v-model="item.email"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.product')"
                          :placeholder="$t('app.modules.register.headers.product')"
                          v-model="item.quantity"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.quantity')"
                          :placeholder="$t('app.modules.register.headers.quantity')"
                          v-model="item.quantity"
                        >
                        </fg-input>

                        <fg-input
                          type="text"
                          :label="$t('app.modules.register.headers.state')"
                          :placeholder="$t('app.modules.register.headers.state')"
                          v-model="item.state"
                        >
                        </fg-input>
                      </div>
                    </div>
                    <div class="row" style="margin-top: 20px;">
                      <div class="col-4"></div>
                      <div class="col-4">
                        <n-button type="primary" round block>
                          {{ $t('app.modules.register.buttons.send') }}
                        </n-button>
                      </div>
                      <div class="col-4"></div>
                    </div>
                  </div>
                </card>
              </div>
              <div class="col-1"></div>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      </form>
    </ValidationObserver>



  </div>

  <!--<div>


  </div>-->
</template>
<script>
//import { Checkbox } from "src/components";
//import { extend } from "vee-validate";
//import { required, email, confirmed } from "vee-validate/dist/rules";

//extend("email", email);
//extend("required", required);
//extend("confirmed", confirmed);

export default {
  components: {
    //Checkbox
  },
  data() {
    return {
      item: {
        business_name: "",
        tel: "",
        rfc: "",
        email: "",
        fullname: "",
        product: "",
        country: "",
        quantity: "",
        state: "",
        comment: ""
      }
    };
  },
  methods: {
    /*async register() {
      let isValidForm = await this.$validator.validate();
      if (isValidForm) {
        // TIP use this.model to send it to api and perform register call
      }
    },
    submit() {
      alert("Form has been submitted!");
    }*/
  }
};
</script>
<style>
/*.contentr {
  margin: 0 10%;
}
.form {
  padding: 0 10%;
}*/

</style>
<style scoped>
  h4 {
    font-weight: bold;
  }
  button {
    width: 100% !important;
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
  }
</style>
